/* ============================================
   BUYERSIGNUP.JSX
   📁 File location: src/screens/buyer/auth/BuyerSignup.jsx
   ✅ Bilkul SellerSignup jesa layout
   ✅ Profile Image upload added
   ✅ Phone number + Location fields
   ✅ buyer- prefix CSS classes
   ✅ Sab existing states + API calls same
   ============================================ */

import React, { useContext, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome, FaEye, FaEyeSlash, FaCamera,
} from "react-icons/fa";
import "../../../assets/css/Buyer/dashboard/buyerauth/buyerauth.css";
import logo from "../../../assets/images/logo.png";
import axios from "axios";
import AppContext from "context/AppContext";

function BuyerSignup() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================
  const { baseUrl, Navigate, regExpChecker } = useContext(AppContext);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [location, setLocation] = useState("");
  const [status, setStatus] = useState("Active");

  // ✅ Profile Image states
  // const [profileImage, setProfileImage] = useState(null);
  // const [profileImagePreview, setProfileImagePreview] = useState(null);
  // const profileImageRef = useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // ==========================================
  // TOGGLE PASSWORD VISIBILITY
  // ==========================================
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  // ==========================================
  // ✅ PROFILE IMAGE HANDLER
  // ==========================================
  // const handleProfileImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
  //   if (!allowedTypes.includes(file.type)) {
  //     setErrorMessage("Only JPG, PNG or WEBP images are allowed.");
  //     return;
  //   }
  //   if (file.size > 2 * 1024 * 1024) {
  //     setErrorMessage("Image size must be less than 2MB.");
  //     return;
  //   }

  //   setProfileImage(file);
  //   setProfileImagePreview(URL.createObjectURL(file));
  //   setErrorMessage("");
  // };

  // ==========================================
  // HANDLE FORM SUBMISSION
  // ==========================================
  const handleSubmit = (e) => {
    e.preventDefault();
    signupbuyer();
  };

  const signupbuyer = () => {
    setIsLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("phonenumber", phoneNumber);
    formData.append("location", location);
    formData.append('status', status);
    // if (profileImage) {
    //   formData.append("profileImage", profileImage);
    // }

    axios.post(`${baseUrl}/buyer/auth/signup`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          sendOtp();
        } else {
          setErrorMessage("Signup failed. Please try again.");
          console.log(response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Something went wrong. Please try again.");
        setIsLoading(false);
      });
  };
  // ==========================================
  // Send Otp
  // ==========================================
  const sendOtp = () => {
    axios.post(`${baseUrl}/buyer/otp/sendOtp`, {
      email: email
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          Navigate("/buyer/otpverification", {
            state: { 
              email: email, 
              from: "signup", 
            },
          });
        } else {
          setErrorMessage("OTP could not be sent.");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Something went wrong.");
        setIsLoading(false);
      });
  }

  // ==========================================
  // RENDER COMPONENT
  // ==========================================
  return (
    <div className="buyer-page-container">
      <div className="buyer-card">

        {/* ==========================================
            LEFT SIDE — PROMO SECTION
            ========================================== */}
        <div className="buyer-promo-section">
          <div className="buyer-promo-bg"></div>
          <div className="buyer-floating-shape buyer-floating-shape-1"></div>
          <div className="buyer-floating-shape buyer-floating-shape-2"></div>
          <div className="buyer-floating-shape buyer-floating-shape-3"></div>

          <div className="buyer-promo-content">

            <img
              src={logo}
              alt="Estate Experts"
              className="navbar-logo"
            />

            <span className="buyer-brand-text">Estate Experts</span>
            <h2 className="buyer-promo-title">Already Signed up?</h2>
            <p className="buyer-promo-description">
              Log in to your account so you can continue building and editing your onboarding flows.
            </p>
            <Link to="/buyer/login" className="buyer-promo-btn">
              LOG IN
            </Link>
          </div>
        </div>

        {/* ==========================================
            RIGHT SIDE — SIGNUP FORM
            ========================================== */}
        <div className="buyer-form-section">
          <div className="buyer-form-container">
            <h1 className="buyer-form-title">Sign Up for an Account</h1>

            {/* Error Message */}
            {errorMessage && (
              <div className="buyer-error-message">{errorMessage}</div>
            )}

            {/* Success Message */}
            {successMessage && (
              <div className="buyer-success-message">{successMessage}</div>
            )}

            {/* Form */}
            <form onSubmit={handleSubmit}>
              {/* First Name & Last Name */}
              <div className="buyer-form-row">
                <div className="buyer-form-group">
                  <label className="buyer-form-label">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      setErrorMessage(regExpChecker("fullName", e.target.value));
                    }}
                    placeholder="Your first name"
                    className="buyer-form-input"
                    required
                  />
                </div>
                <div className="buyer-form-group">
                  <label className="buyer-form-label">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      setErrorMessage(regExpChecker("fullName", e.target.value));
                    }}
                    placeholder="Your last name"
                    className="buyer-form-input"
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div className="buyer-form-group">
                <label className="buyer-form-label">Email</label>
                <div className="buyer-input-wrapper">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrorMessage(regExpChecker("email", e.target.value));
                    }}
                    placeholder="Enter your email address"
                    className="buyer-form-input"
                    required
                  />
                </div>
              </div>

              {/* Password */}
              <div className="buyer-form-group">
                <label className="buyer-form-label">Password</label>
                <div className="buyer-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrorMessage(regExpChecker("password", e.target.value));
                    }}
                    placeholder="Enter a strong password"
                    className="buyer-form-input"
                    required
                  />
                  <span
                    className="buyer-password-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              {/* Phone Number & Location */}
              <div className="buyer-form-row">
                <div className="buyer-form-group">
                  <label className="buyer-form-label">Phone Number</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="+92 300 0000000"
                    className="buyer-form-input"
                    required
                  />
                </div>
                <div className="buyer-form-group">
                  <label className="buyer-form-label">Location</label>
                  <input
                    type="text"
                    name="location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    placeholder="e.g., Lahore, Pakistan"
                    className="buyer-form-input"
                    required
                  />
                </div>
              </div>
              {/* Terms & Conditions */}
              {/* <div className="buyer-terms-wrapper">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  className="buyer-checkbox"
                />
                <label htmlFor="acceptTerms" className="buyer-terms-text">
                  I accept Estate Experts's{" "}
                  <Link to="/terms" className="buyer-terms-link">
                    Terms & Conditions
                  </Link>
                </label>
              </div> */}
              {/* Submit Button */}
              <button
                type="button"
                onClick={signupbuyer}
                className={`buyer-submit-btn ${isLoading ? "buyer-btn-loading" : ""}`}
              >
                {isLoading ? "Creating Account..." : "SIGN UP"}
              </button>

            </form>
          </div>
        </div>

      </div>
    </div>
  );
}

export default BuyerSignup;